<template>
  <UBindIFrame
    pageTitle="Rideshare"
    productType="ride-protect"
    :sendEmailAction="sendEmail"
  />
</template>

<script>
import UBindIFrame from "../../components/UBindIFrame.vue";
import { GlobalStore } from "../../globalStore";
import { emailMethods } from "../../helpers/email";
import { toasts } from "../../helpers/toasts";
import { appFunctions } from "../../helpers/appFunctions";

export default {
  name: "Step2",
  methods: {
    async sendEmail() {
      const mostRecentRSPolicyId = sessionStorage.getItem(
        "mostRecentRSPolicyId"
      );

      const customerDetails = await appFunctions.crud_customerRSPolicy(
        "getCombined",
        {
          policy_id: parseInt(mostRecentRSPolicyId)
        }
      );

      await emailMethods.sendContinueQuoteEmail(
        GlobalStore.realmApp,
        customerDetails.data,
        "RS"
      );

      toasts.success(
        `Email has been sent to ${customerDetails.data.Customer_contact_email}`
      );

      this.$router.push("/rideShare/quoteEmailed");
    }
  },
  components: {
    UBindIFrame
  }
};
</script>

<style lang="scss" scoped>
.top-padding {
  padding-top: 0px !important;
}

.ubind-product {
  margin: 0px 15px 0px 15px;
}
.container-fluid {
  padding-left: 0px;
  padding-left: 0px;
  padding-right: 0px;
}
</style>
